module.exports = "<p>\n  Le mailing a bien été validé\n</p>\n"